import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import App from 'containers/App';
import store from 'store';

render(
  <Provider store={ store }>
    <DndProvider backend={ HTML5Backend }>
      <App />
    </DndProvider>
  </Provider>,
  document.getElementById('root')
);
